module.exports = __webpack_public_path__ + "img/main.143dbd74.png";